import { useMatch } from 'react-router';
import { IndependentIraTransactions, IraUserTransactions } from 'screens';
import {
  ROUTE_CONTRIBUTION_DETAIL_IRA_ACCOUNT_TRANSACTIONS,
  ROUTE_CONTRIBUTION_DETAIL_IRA_USER_TRANSACTIONS,
} from 'constants/routes';

const ContributionDetailUserTransactions = (): JSX.Element => {
  const isIRAUser = useMatch(ROUTE_CONTRIBUTION_DETAIL_IRA_USER_TRANSACTIONS);
  const isIRAAccount = useMatch(ROUTE_CONTRIBUTION_DETAIL_IRA_ACCOUNT_TRANSACTIONS);

  if (isIRAUser) {
    return <IraUserTransactions />;
  }
  if (isIRAAccount) {
    return <IndependentIraTransactions />;
  }
  return <></>;
};

export default ContributionDetailUserTransactions;
